import { ObjectManager } from './../objectModelV2/objectManager';

export const SET_APP_STATE = 'SET_APP_STATE';
export const AUTH_FAILED = 'AUTH_FAILED';
export const SET_APP_TEXT = 'SET_APP_TEXT';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_OBJECT_MANAGER = 'SET_OBJECT_MANAGER';
export const SET_NAV_BAR_COLLAPSED_STATE = 'SET_NAV_BAR_COLLAPSED_STATE';
export const SET_MEASUREMENT_DATA = "SET_MEASUREMENT_DATA";
export const SET_OLD_MEASUREMENT_DATA = "SET_OLD_MEASUREMENT_DATA";
export const RESET_CACHED_MEASUREMENT_DATA = "RESET_CACHED_MEASUREMENT_DATA";
export const SET_MEASUREMENT_DATA_CACHED_STATE = "SET_MEASUREMENT_DATA_CACHED_STATE";
export const SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE  = "SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE";
export const SET_PRELOAD_OBJECTS_STATE = "SET_PRELOAD_OBJECTS_STATE";
export const SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE = "SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE";
export const RESET_PRELOADED_OBJECTS_STATE = "RESET_PRELOADED_OBJECTS_STATE";

export const setAppState = (appState: string): BernerAction => {
    return {
        type: SET_APP_STATE,
        payload: {
            appState,
        },
    };
};

export const authFailed = (error: AuthError): BernerAction => {
    return {
        type: AUTH_FAILED,
        payload: {
            error,
        },
    };
};

export const setAppText = (applicationText: any): BernerAction => {
    return {
        type: SET_APP_TEXT,
        payload: {
            applicationText,
        },
    };
};

export const setUserEmail = (userEmail: string): BernerAction => {
    return {
        type: SET_USER_EMAIL,
        payload: {
            userEmail: userEmail,
        },
    };
};

export const setNavBarCollapsedState = (collapsed: boolean): BernerAction => {
    return {
        type: SET_NAV_BAR_COLLAPSED_STATE,
        payload: {
            navBarCollapsedState: collapsed,
        },
    };
};

export const setObjectManager = (
    objectManager: ObjectManager
): BernerAction => {
    return {
        type: SET_OBJECT_MANAGER,
        payload: {
            objectManager,
        },
    };
};

export const setMeasurementData = (
    deviceId: string,
    measurementData: MeasurementData) : BernerAction => {
    return {
        type: SET_MEASUREMENT_DATA,
        payload: {
            deviceId,
            measurementData,
        },
    };
};

export const setOldMeasurementData = (
    deviceId: string,
    measurementDataOld: MeasurementData) : BernerAction => {
    return {
        type: SET_OLD_MEASUREMENT_DATA,
        payload: {
            deviceId,
            measurementDataOld,
        },
    };
};

export const setMeasurementDataCachedState = (cached: boolean): BernerAction => {
    return {
        type: SET_MEASUREMENT_DATA_CACHED_STATE,
        payload: {
            measurementDataCachedState: cached,
        },
    };
};

export const setMeasurementDataCachingInProgressState = (): BernerAction => {
    return {
        type: SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE,
        payload: {
            measurementDataCachingInProgressState: true,
        },
    };
};

export const resetCachedMeasurementData = () : BernerAction => {
    return {
        type: RESET_CACHED_MEASUREMENT_DATA,
        payload: {},
    };
};

export const setPreloadObjectsState = (preloaded: boolean): BernerAction => {
    return {
        type: SET_PRELOAD_OBJECTS_STATE,
        payload: {
            preloadObjectsState: preloaded,
        },
    };
};

export const setPreloadObjectsInProgressState = (): BernerAction => {
    return {
        type: SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE,
        payload: {
            preloadObjectsInProgressState: true,
        },
    };
};

export const resetPreloadedObjectsState = (): BernerAction => {
    return {
        type: RESET_PRELOADED_OBJECTS_STATE,
        payload: {},
    };
};
